var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_427_3",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_427_3",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACl0lEQVR4nO2duY4TQRRFK2f5AzLESFPX8ynwJ6Qgttx1J0HiX/iLYcsYlgQClgSpakxm1BITgBgZ90h9X3fdI72sLHedY7vVTiolY4wxxhgzQ8qq3WFuX0tuX44P2+2lrw8PUT8TbTtMyfXT0teH53wz57P09eGJJoxLD/L05vfrRH1ScntD1M3fG7hoQ7vWcTbr66bk9rqgPl4ffLuWlKxXPw5Krh/+dzPzENxGry+5vj8++nkrKRg+DcMF7BNDLYwTrC+op88Ot1fT1JRcH+4bI4IwTrC+oN5PU1PQXjpIuyjKi+mD5HrmIO3fQXJtkwcZE4O5fhxee5zPbix9fZpFELS7vzfzfOnr00yCdDPJQZo8goNAL95BoJftINALdhDopToI9CIdJIA8OoheGB1EL4kOohdDB9HLYIDxXyfQR3AQ6MXPPkgKBh0kFnSQWNBBYsHeg/QyyUGaPIKDQC/eQaCX7SDQC3YQ6KU6CPQiHSSAPDqIXhgdRC+JDhLgCfaSjI142fdd7oX2ss/ZXGgv+5zNhfayT/VNk8HHQaCP4CDQi3cQ6GU7CPSCHQR6qQ4CvUgHCSCPDqIXRgfRS6KDBHiC3UH3P1kpGOz9HpKCQQeJBXsP0sskB2nyCA4CvXgHgV62g0Av2EGgl+og0It0kADy6CB6YXQQvSQ6SIAn2D3p7h6SgkMHiQUdJBbsLUgvkxykySM4CPTiHQR62Q4CvWAHgV6qg0Av0kECyKOD6IXRQfSSuOQgYw+W7GKy4GDJsUev9jAF7WTyIOtcH6g3zqizqvcmDzIcUU3Ud/LNI9rUtzzaXkkKhsPcx5ypvtQpqKeyA+7/+Kbk+oi5vSLqpsNvxGa4nw4/4ZKD7Y0xxhhjTNrNL9b5acQhLAYRAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteIcon);
export default __webpack_public_path__ + "static/media/noteIcon.c4fe7443ca02b55a0a1fdac439359840.svg";
export { ForwardRef as ReactComponent };